import React from 'react'
import { useTranslation } from 'react-i18next'
import './ourServices.scss';

const InteligenciaArtificialService = () => {
    const { t } = useTranslation();

    return (
        <div className="our-services">
            <div className="our-services__container">
                <div className="our-services__content">
                    <h2 className="our-services__title">
                        {t('services.ourServices.ai.title')}
                    </h2>
                    <div
                        className="our-services__title-line"
                    />
                    <p className="our-services__text">
                        {t('services.ourServices.ai.lead')}
                    </p>
                    <p className="our-services__text">
                        {t('services.ourServices.ai.p1')}
                    </p>
                    <p className="our-services__text">
                        {t('services.ourServices.ai.p2')}
                    </p>
                </div>
                <div className="our-services__solutions">
                    <h3 className="our-services__subtitle">{t('services.ourServices.solutionsTitle')}</h3>
                    <ul className="our-services__list">
                        <li className="our-services__item">
                            <p className="our-services__item-title">{t('services.ourServices.ai.item1Title')}</p>
                            <p className="our-services__item-desc">{t('services.ourServices.ai.item1Desc')}</p>
                        </li>
                        <li className="our-services__item">
                            <p className="our-services__item-title">{t('services.ourServices.ai.item2Title')}</p>
                            <p className="our-services__item-desc">{t('services.ourServices.ai.item2Desc')}</p>
                        </li>
                        <li className="our-services__item">
                            <p className="our-services__item-title">{t('services.ourServices.ai.item3Title')}</p>
                            <p className="our-services__item-desc">{t('services.ourServices.ai.item3Desc')}</p>
                        </li>
                        <li className="our-services__item">
                            <p className="our-services__item-title">{t('services.ourServices.ai.item4Title')}</p>
                            <p className="our-services__item-desc">{t('services.ourServices.ai.item4Desc')}</p>
                        </li>
                        <li className="our-services__item">
                            <p className="our-services__item-title">{t('services.ourServices.ai.item5Title')}</p>
                            <p className="our-services__item-desc">{t('services.ourServices.ai.item5Desc')}</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default InteligenciaArtificialService